<section class="admin-users evp plc">

  <div class="admin-users__toolbar evp__toolbar">
    <div class="evp__filters">
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Quelle' ) %></span>
        <select class="field__input field__select" data-id="filter-source"></select>
      </label>
      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Status' ) %></span>
        <select class="field__input field__select" data-id="filter-status">
          <option value=""><%= _lcs( 'Alle' ) %></option>
          <option value="published"><%= _lcs( 'Veröffentlicht' ) %></option>
          <option value="draft"><%= _lcs( 'Entwurf' ) %></option>
          <option value="archived"><%= _lcs( 'Archiviert' ) %></option>
        </select>
      </label>
      <!-- Multi-select: a native <select multiple> would break the toolbar's
           single-row layout and needs ctrl-clicking to use. -->
      <div class="evp__filter evp__filter--multi">
        <span class="evp__filter-label"><%= _lcs( 'Kategorie' ) %></span>
        <button type="button" class="field__input evp__multi-toggle" data-id="filter-category-toggle" aria-expanded="false">
          <span data-id="filter-category-label"><%= _lcs( 'Alle Kategorien' ) %></span>
          <i class="icon icon--chevron-down"></i>
        </button>
        <div class="evp__multi-panel" data-id="filter-category-panel" hidden>
          <div class="evp__multi-list" data-id="filter-category-list"></div>
          <button type="button" class="evp__multi-clear" data-id="filter-category-clear"><%= _lcs( 'Auswahl aufheben' ) %></button>
        </div>
      </div>

      <label class="evp__filter">
        <span class="evp__filter-label"><%= _lcs( 'Dubletten' ) %></span>
        <select class="field__input field__select" data-id="filter-duplicates">
          <option value="exclude"><%= _lcs( 'Ausblenden' ) %></option>
          <option value="include"><%= _lcs( 'Mit anzeigen' ) %></option>
          <option value="only"><%= _lcs( 'Nur Dubletten' ) %></option>
        </select>
      </label>
    </div>
    <button type="button" class="btn btn--ghost btn--sm" data-id="btn-reload">
      <i class="icon icon--rotate-cw"></i> <%= _lcs( 'Aktualisieren' ) %>
    </button>
  </div>

  <p class="evp__truncated" data-id="truncated" hidden></p>

  <!-- Grid (or loading / empty / error message) is rendered here by GastroList.js -->
  <div class="admin-users__state" data-id="places-state"></div>

  <!-- Detail panel (web component) -->
  <place-detail data-id="place-detail"></place-detail>

</section>
